import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Result, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import CategoryBoardNoSub from "../component/category/CategoryBoardNoSub";
import { getBoardListWithRootCategory } from "../api/categoryAPI";

const DedicatedBoard = () => {
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const boardName = queryParams.get("board");

    setIsUnauthorized(false);
    setCategoryId(null);

    if (boardName) {
      setLoading(true);
      
      getBoardListWithRootCategory().then((data) => {
        const targetBoard = data.find((item: any) => item.name === boardName);

        if (targetBoard) {
          setCategoryId(targetBoard.rootCategories[0]?.id || null);
        } else {
          console.warn(`'${boardName}' 접근 권한이 없거나 없는 게시판입니다.`);
          setIsUnauthorized(true); 
        }
      }).catch((error) => {
        console.error("게시판 목록을 불러오는 중 에러 발생:", error);
        setIsUnauthorized(true);
      }).finally(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
      setIsUnauthorized(true);
    }
  }, [location.search]);

  if (loading) {
    return (
      <Layout.Content style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <LoadingOutlined style={{ fontSize: 48, color: "#1677ff" }} spin />
      </Layout.Content>
    );
  }

  if (isUnauthorized) {
    return (
      <Layout.Content style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Result
          status="403"
          title="접근 권한 없음"
          subTitle="해당 게시판에 접근 권한이 없습니다."
          extra={
            <Button type="primary" onClick={() => navigate("/")}>
              메인으로 돌아가기
            </Button>
          }
        />
      </Layout.Content>
    );
  }

  if (!categoryId) {
    return (
      <Layout.Content style={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Result
          status="warning"
          title="카테고리 없음"
          subTitle="이 게시판에는 아직 설정된 카테고리가 없습니다."
        />
      </Layout.Content>
    );
  }

  return (
    <>
      <CategoryBoardNoSub rootCategoryId={categoryId} />
    </>
  );
};

export default DedicatedBoard;